export default __webpack_public_path__ + "static/media/Mask Group 5@2x.b65e90cf.png";